import { Alert, AlertProps, AlertTitle, Button, Stack } from '@mui/material'
import { Heater } from '../types'
import { useTranslation } from 'react-i18next'
import HeaterDetachButton from './HeaterDetachButton'
import { usePolicy } from '../hooks'

export interface HeaterDetachAlertProps extends Omit<AlertProps, 'children'> {
  heater: Heater
  title?: string
  afterUpdate?: (heater: Heater) => void
  onCancel?: () => void
}

export default function HeaterDetachAlert({
  heater,
  title,
  afterUpdate,
  onCancel,
  sx,
  ...props
}: HeaterDetachAlertProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation('heater')

  /**
   * The policy state.
   */
  const { canEditHeater } = usePolicy()

  return (
    <>
      {heater?.deviceName && canEditHeater(heater) && (
        <Alert
          severity="warning"
          sx={{
            '& .MuiAlert-message': {
              width: '100%'
            },
            ...sx
          }}
          {...props}
        >
          <AlertTitle sx={{ m: 0 }}>{title ?? t('HeaterDetachAlert.title')}</AlertTitle>

          <Stack direction="row" alignItems="center" gap={2} sx={{ mt: 1 }}>
            <HeaterDetachButton
              heater={heater}
              variant="outlined"
              color="inherit"
              size="small"
              afterSubmit={afterUpdate}
            >
              {t('HeaterDetachAlert.yes')}
            </HeaterDetachButton>

            <Button variant="outlined" color="inherit" size="small" onClick={onCancel}>
              {t('HeaterDetachAlert.no')}
            </Button>
          </Stack>
        </Alert>
      )}
    </>
  )
}
